import { createSelector } from "reselect";
import finVehicleDomainData from "../domain-data/FinVehicleDomainData";

// Format Origin options for autotype dropdown

export const selectLocationOptions = createSelector(
  [finVehicleDomainData.selectors.getLocations],
  (locations) => locations.map((l) => `${l.name} (${l.code})`),
);
